import { useState, useEffect } from "react";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db, storage } from "../../../util/firebase";
import { query, collection, getDocs, where, addDoc } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";

import { v4 as uuidv4 } from "uuid";

import { useNavigate, useParams } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { Button, Input, Modal, ModalBody } from "reactstrap";

function AdminNewsArticlePage() {
  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const params = useParams();
  const articleType = params.articleType;

  const [userData, setUserData] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      setUserData(data);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };
  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  // eslint-disable-next-line
  const [image, setImage] = useState();
  const [title, setTitle] = useState();
  const [text, setText] = useState();

  const createNewsArticle = async () => {
    try {
      setIsLoading(true);

      await addDoc(collection(db, "newsArticles"), {
        uid: uuidv4(),
        dateCreated: new Date().toISOString(),
        image: image,
        title: title,
        text: text,
        type: articleType,
        author: userData.firstName + " " + userData.lastName,
      });

      navigate(-1);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert(err.message);
      setIsLoading(false);
    }
  };

  const [isModalLoading, setIsModalLoading] = useState(false);
  const [newArticleImage, setNewArticleImage] = useState();

  const [
    changeNewsArticleImageModalIsVisible,
    setChangeNewsArticleImageModalIsVisible,
  ] = useState();
  const toggleChangeNewsArticleImageModal = () => {
    setChangeNewsArticleImageModalIsVisible(
      !changeNewsArticleImageModalIsVisible
    );
  };

  const selectNewArticleImage = () => {
    document.getElementById("selectImage").click();
  };

  const [newArticleImagePreview, setNewArticleImagePreview] = useState();
  // Handles input change event and updates state
  const handleChangeNewArticleImage = (event) => {
    setNewArticleImage(event.target.files[0]);
    setNewArticleImagePreview(URL.createObjectURL(event.target.files[0]));
  };

  const handleUploadNewArticleImage = () => {
    const storageRef = ref(
      storage,
      `assets/newsArticleImages/${newArticleImage.name}`
    );
    const uploadTask = uploadBytesResumable(storageRef, newArticleImage);
    setIsModalLoading(true);
    uploadTask.on(
      "state_changed",
      null,
      (error) => console.log(error),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          console.log("File available at", downloadURL);
          try {
            setNewArticleImage(downloadURL);
            setImage(downloadURL);

            setIsModalLoading(false);
            toggleChangeNewsArticleImageModal();
          } catch (err) {
            console.error(err);
            alert(err.message);
            setIsModalLoading(false);
          }
        });
      }
    );
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        ARTICLE
      </h1>
      <div>
        <div id="adminNewsArticleImageContainer">
          <img
            alt="newsArticleImage"
            src={
              image
                ? image
                : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
            }
            id="newsArticleImage"
          />
          <div className="adminNewsArticleImageOverlay">
            <Button
              onClick={toggleChangeNewsArticleImageModal}
              className="primaryBtn"
            >
              ADD
            </Button>
            <Modal
              id="changeNewsArticleImageModal"
              isOpen={changeNewsArticleImageModalIsVisible}
              toggle={toggleChangeNewsArticleImageModal}
              size={"lg"}
            >
              <ModalBody>
                <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                  <div></div>
                  <IoClose onClick={toggleChangeNewsArticleImageModal} />
                </div>
                <div>
                  <h1>ADD IMAGE</h1>
                  {isModalLoading ? (
                    <div
                      style={{
                        height: 300,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <BarLoader color="#005EE1" />
                    </div>
                  ) : (
                    <div style={{ marginTop: "1rem" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginBottom: "1rem",
                        }}
                      >
                        <img
                          alt="articleImage"
                          src={
                            newArticleImagePreview
                              ? newArticleImagePreview
                              : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FnewsArticleImages%2FplaceholderNewsArticleImage.png?alt=media&token=7dc5d843-7704-4877-80e6-7003edb8df4b"
                          }
                          style={{ height: 250, width: 651.4 }}
                        />
                      </div>
                      <Input
                        id="selectImage"
                        type="file"
                        className="mainInput"
                        accept="image/*"
                        onChange={handleChangeNewArticleImage}
                        style={{ display: "none" }}
                      />
                      <Button
                        onClick={selectNewArticleImage}
                        className="secondaryBtn"
                        style={{ marginBottom: "0.5rem" }}
                      >
                        {newArticleImage?.name
                          ? newArticleImage.name
                          : "CHOOSE IMAGE (1310x500px)"}
                      </Button>
                      <Button
                        onClick={handleUploadNewArticleImage}
                        disabled={!newArticleImage?.name}
                        className="primaryBtn"
                      >
                        ADD
                      </Button>
                    </div>
                  )}
                </div>
              </ModalBody>
            </Modal>
          </div>
        </div>
        <input
          type="text"
          className="mainInput"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="The article's title"
          style={{ marginBottom: "0.5rem" }}
        />
        <textarea
          className="mainInput"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="The article's text"
          style={{ height: 300, borderRadius: 20, paddingTop: "1rem" }}
        ></textarea>
        <Button
          onClick={createNewsArticle}
          className="primaryBtn"
          style={{ marginTop: "0.5rem" }}
          disabled={!image || !title || !text}
        >
          CREATE
        </Button>
      </div>
    </div>
  );
}

export default AdminNewsArticlePage;
